import { axiosCustom } from '@/plugins/axios'

export class Group {
  getUserGroupsInSystem() {
    return axiosCustom.get('/v1/users/groups').then((response) => response.data)
  }
}
